var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrOverrideReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.031,
    height: 13,
    viewBox: "0 0 13.031 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle-o",
    transform: "translate(0 -1.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M8.209,5.226l.915.915L7.416,7.82,9.124,9.5l-.915.915L6.5,8.736,4.822,10.414,3.906,9.5,5.585,7.82,3.906,6.142l.915-.915L6.5,6.9ZM6.515,1.32a6.278,6.278,0,0,1,4.608,1.907A6.26,6.26,0,0,1,13.031,7.82a6.26,6.26,0,0,1-1.907,4.593A6.278,6.278,0,0,1,6.515,14.32a6.278,6.278,0,0,1-4.608-1.907A6.26,6.26,0,0,1,0,7.82,6.26,6.26,0,0,1,1.907,3.227,6.278,6.278,0,0,1,6.515,1.32Zm0,11.718a5.012,5.012,0,0,0,3.677-1.526A5.03,5.03,0,0,0,11.718,7.82a5.03,5.03,0,0,0-1.526-3.693A5.012,5.012,0,0,0,6.515,2.6,5.012,5.012,0,0,0,2.838,4.128,5.03,5.03,0,0,0,1.312,7.82a5.03,5.03,0,0,0,1.526,3.692A5.012,5.012,0,0,0,6.515,13.038Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrOverrideReject);
export default __webpack_public_path__ + "static/media/HR Override (Reject).a30435301cc0863d7568980ca6cfde14.svg";
export { ForwardRef as ReactComponent };